import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import LzFormFieldInput from '../../../commons/forms/fields/input';
import { lzDeepVarSet } from '../../../../services/LzType';
import { lzGetFormattedDate } from '../../../../services/LzMoment';
import { lzCallApi } from '../../../../services/LzApiService';
import LzFormFieldStatic from '../../../commons/forms/fields/static';
import CreditCardInfoModel from '../../../../models/credit-card-info';
import GatewaySubscriptionModel from '../../../../models/gateway-subscription';

class SubscriptionPaymentComponent extends React.Component {

    constructor(props) {
        super(props);
        const gateway = GatewaySubscriptionModel.getGateway(props.subscription?.gateway_subscription?.gateway);
        const subscriptionDetails = GatewaySubscriptionModel.getDetailsObject(gateway, props.subscription?.gateway_subscription?.details);
        if (!props.viewOnly) { // in case of NOT view only, reset the credit card info, so that it is taken input all over again
            subscriptionDetails.credit_card_info = new CreditCardInfoModel();
        }
        this.state = {
            gateway: gateway,
            subscriptionDetails: subscriptionDetails,
            formState: '' === subscriptionDetails.credit_card_info.card_number ? 1 : 3,
        };
    }

    handleInputChange = (name, value) => {
        const { subscriptionDetails } = this.state;
        this.setState({ subscriptionDetails: Object.assign({}, subscriptionDetails, lzDeepVarSet(subscriptionDetails, name, value)) });
    };

    copyBillingToShipping = () => {
        const { subscriptionDetails } = this.state;
        this.setState({ subscriptionDetails: Object.assign({}, subscriptionDetails, { shipping_info: Object.assign({}, subscriptionDetails.billing_info) }) });
    };

    copyShippingToBilling = () => {
        const { subscriptionDetails } = this.state;
        this.setState({ subscriptionDetails: Object.assign({}, subscriptionDetails, { billing_info: Object.assign({}, subscriptionDetails.shipping_info) }) });
    };

    async save() {
        const { gateway, subscriptionDetails } = this.state;
        const { onReload } = this.props;

        const data = await lzCallApi('subscription/create', {
            gateway: gateway,
            details: subscriptionDetails,
        }, 'post');

        if (data) {
            onReload();
        }
    }

    onSubmit(ev) {
        ev.preventDefault();
        this.save();
    }

    render() {
        const { gateway, subscriptionDetails, formState } = this.state;
        const { viewOnly, onRequestCancellation } = this.props;
        const details = GatewaySubscriptionModel.getDetailsObject(gateway, subscriptionDetails);

        const currYear = +lzGetFormattedDate('now', 'YYYY');

        // console.log(details);

        return (
            <React.Fragment>

                {viewOnly ?
                    <React.Fragment>
                        <Typography variant="h5" style={{ textAlign: 'center', margin: 24 }}>Subscription Details</Typography>
                        <Grid container spacing={2}>

                            <Grid item sm={6} md={6}>
                                <Typography variant="h6">Billing Information:</Typography>
                                <Grid container spacing={1}>
                                    <Grid item sm={6}>
                                        <LzFormFieldStatic fluid compact label="First Name" value={details.billing_info.first_name} />
                                    </Grid>
                                    <Grid item sm={6}>
                                        <LzFormFieldStatic fluid compact label="Last Name" value={details.billing_info.last_name} />
                                    </Grid>
                                    <Grid item sm={12}>
                                        <LzFormFieldStatic fluid compact label="Company Name" value={details.billing_info.company_name} />
                                    </Grid>
                                    <Grid item sm={12}>
                                        <LzFormFieldStatic fluid compact label="Address" value={details.billing_info.address} />
                                    </Grid>
                                    <Grid item sm={4}>
                                        <LzFormFieldStatic fluid compact label="City" value={details.billing_info.city} />
                                    </Grid>
                                    <Grid item sm={4}>
                                        <LzFormFieldStatic fluid compact label="State" value={details.billing_info.state} />
                                    </Grid>
                                    <Grid item sm={4}>
                                        <LzFormFieldStatic fluid compact label="Zip" value={details.billing_info.zip} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {false &&
                                <Grid item sm={6} md={4}>
                                    <Typography variant="h6">Shipping Information:</Typography>
                                    <Grid container spacing={1}>
                                        <Grid item sm={6}>
                                            <LzFormFieldStatic fluid compact label="First Name" value={details.shipping_info.first_name} />
                                        </Grid>
                                        <Grid item sm={6}>
                                            <LzFormFieldStatic fluid compact label="Last Name" value={details.shipping_info.last_name} />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <LzFormFieldStatic fluid compact label="Company Name" value={details.shipping_info.company_name} />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <LzFormFieldStatic fluid compact label="Address" value={details.shipping_info.address} />
                                        </Grid>
                                        <Grid item sm={4}>
                                            <LzFormFieldStatic fluid compact label="City" value={details.shipping_info.city} />
                                        </Grid>
                                        <Grid item sm={4}>
                                            <LzFormFieldStatic fluid compact label="State" value={details.shipping_info.state} />
                                        </Grid>
                                        <Grid item sm={4}>
                                            <LzFormFieldStatic fluid compact label="Zip" value={details.shipping_info.zip} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }

                            <Grid item sm={6} md={6}>
                                <Typography variant="h6">Credit Card Information:</Typography>
                                <Grid container spacing={1}>
                                    <Grid item sm={12}>
                                        <LzFormFieldStatic fluid compact label="Name on Credit Card" value={details.credit_card_info.name_on_card} />
                                    </Grid>
                                    <Grid item sm={12}>
                                        <LzFormFieldStatic fluid compact label="Credit Card Number" value={details.credit_card_info.card_number} />
                                    </Grid>
                                    <Grid item sm={6}>
                                        <LzFormFieldStatic fluid compact label="Credit Card Expiry" value={details.credit_card_info.card_expiry} />
                                    </Grid>
                                    <Grid item sm={6}>
                                        <LzFormFieldStatic fluid compact label="CVV Code" value={details.credit_card_info.card_code} />
                                    </Grid>
                                    <Grid item sm={12} style={{ textAlign: 'right' }}>
                                        {onRequestCancellation &&
                                            <Button color="secondary" variant="contained" size="small" endIcon={<CancelIcon />}
                                                onClick={onRequestCancellation}>Cancel Subscription</Button>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        {/*
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="6HAVKWWA36J26" />
                            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!" />
                            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                        </form>
                        */}
                        <form onSubmit={(ev) => this.onSubmit(ev)}>
                            <Typography variant="h5" style={{ textAlign: 'center', margin: 24 }}>Make Payment for the Subscription:</Typography>
                            <Grid container spacing={2}>

                                <Grid item sm={6} md={6}>
                                    <Typography variant="h6">Billing Information:</Typography>
                                    <Grid container spacing={1}>
                                        <Grid item sm={6}>
                                            <LzFormFieldInput fluid size="small" label="First Name" name="billing_info.first_name"
                                                value={details.billing_info.first_name} onChange={this.handleInputChange} />
                                        </Grid>
                                        <Grid item sm={6}>
                                            <LzFormFieldInput fluid size="small" label="Last Name" name="billing_info.last_name"
                                                value={details.billing_info.last_name} onChange={this.handleInputChange} />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <LzFormFieldInput fluid size="small" label="Company Name" name="billing_info.company_name"
                                                value={details.billing_info.company_name} onChange={this.handleInputChange} />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <LzFormFieldInput fluid size="small" label="Address" name="billing_info.address"
                                                value={details.billing_info.address} onChange={this.handleInputChange} />
                                        </Grid>
                                        <Grid item sm={4}>
                                            <LzFormFieldInput fluid size="small" label="City" name="billing_info.city"
                                                value={details.billing_info.city} onChange={this.handleInputChange} />
                                        </Grid>
                                        <Grid item sm={4}>
                                            <LzFormFieldInput fluid size="small" label="State" name="billing_info.state"
                                                value={details.billing_info.state} onChange={this.handleInputChange} />
                                        </Grid>
                                        <Grid item sm={4}>
                                            <LzFormFieldInput fluid size="small" label="Zip" name="billing_info.zip"
                                                value={details.billing_info.zip} onChange={this.handleInputChange} />
                                        </Grid>
                                        {formState < 2 &&
                                            <Grid item sm={12} style={{ textAlign: 'right' }}>
                                                <Button color="secondary" variant="contained" size="small" endIcon={<KeyboardArrowRightIcon />}
                                                    onClick={() => this.setState({ formState: 3 })}>Next</Button>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>

                                {/*formState > 1*/ false &&
                                    <Grid item sm={6} md={4}>
                                        <Typography variant="h6">Shipping Information:</Typography>
                                        <Grid container spacing={1}>
                                            <Grid item sm={6}>
                                                <LzFormFieldInput fluid size="small" label="First Name" name="shipping_info.first_name"
                                                    value={details.shipping_info.first_name} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={6}>
                                                <LzFormFieldInput fluid size="small" label="Last Name" name="shipping_info.last_name"
                                                    value={details.shipping_info.last_name} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={12}>
                                                <LzFormFieldInput fluid size="small" label="Company Name" name="shipping_info.company_name"
                                                    value={details.shipping_info.company_name} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={12}>
                                                <LzFormFieldInput fluid size="small" label="Address" name="shipping_info.address"
                                                    value={details.shipping_info.address} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={4}>
                                                <LzFormFieldInput fluid size="small" label="City" name="shipping_info.city"
                                                    value={details.shipping_info.city} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={4}>
                                                <LzFormFieldInput fluid size="small" label="State" name="shipping_info.state"
                                                    value={details.shipping_info.state} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={4}>
                                                <LzFormFieldInput fluid size="small" label="Zip" name="shipping_info.zip"
                                                    value={details.shipping_info.zip} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={8}>
                                                <Button onClick={this.copyBillingToShipping} variant="text">Copy from Billing</Button>
                                            </Grid>
                                            {formState < 3 &&
                                                <Grid item sm={4} style={{ textAlign: 'right' }}>
                                                    <Button color="secondary" variant="contained" size="small" endIcon={<KeyboardArrowRightIcon />}
                                                        onClick={() => this.setState({ formState: 3 })}>Next</Button>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                }

                                {formState > 2 &&
                                    <Grid item sm={6} md={6}>
                                        <Typography variant="h6">Credit Card Information:</Typography>
                                        <Grid container spacing={1}>
                                            <Grid item sm={12}>
                                                <LzFormFieldInput fluid size="small" label="Name on Credit Card" name="credit_card_info.name_on_card"
                                                    value={details.credit_card_info.name_on_card} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={12}>
                                                <LzFormFieldInput fluid required size="small" label="Credit Card Number" name="credit_card_info.card_number"
                                                    value={details.credit_card_info.card_number} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={6}>
                                                <LzFormFieldInput fluid required size="small" label="Credit Card Expiry" name="credit_card_info.card_expiry"
                                                    type="monthyear" startYear={currYear} endYear={currYear + 5}
                                                    value={details.credit_card_info.card_expiry} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={6}>
                                                <LzFormFieldInput fluid required size="small" label="CVV Code" name="credit_card_info.card_code"
                                                    value={details.credit_card_info.card_code} onChange={this.handleInputChange} />
                                            </Grid>
                                            <Grid item sm={12} style={{ textAlign: 'right' }}>
                                                <Button type="submit" color="secondary" variant="contained" size="small"
                                                    endIcon={<CheckCircleIcon />}>Submit</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                            </Grid>
                        </form>
                    </React.Fragment>
                }

            </React.Fragment>
        );
    }

}

export default SubscriptionPaymentComponent;
